import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Routes = () => {
  const routes = [
    {
      from: 'Mumbai',
      to: 'Chakan',
      type: 'Specialist Route',
      description: 'Our flagship route with daily departures and specialized handling'
    },
    {
      from: 'Navi Mumbai',
      to: 'Chakan',
      type: 'Specialist Route',
      description: 'Direct service from Navi Mumbai industrial belt to Chakan'
    },
    {
      from: 'Sanpada Godown',
      to: 'Chakan Godown',
      type: 'Daily Service',
      description: 'Fixed daily schedule ensuring consistent delivery times'
    },
    {
      from: 'Mumbai',
      to: 'Pune',
      type: 'Full Load Return Service',
      description: 'Round trip service with return load options'
    },
    {
      from: 'Mumbai',
      to: 'Nashik',
      type: 'Full Load Return Service',
      description: 'Reliable service with flexible scheduling and return trips'
    }
  ];

  return (
    <section id="routes" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-red-600">Routes</span> & Coverage
          </h2>
          <p className="text-lg text-gray-600">
            Strategic routes designed to serve Maharashtra's industrial corridors efficiently.
          </p>
        </div>

        {/* Routes Display */}
        <div className="space-y-6 max-w-4xl mx-auto">
          {routes.map((route, index) => (
            <Card
              key={index}
              className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-yellow-300"
            >
              <CardContent className="p-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex items-center space-x-4 flex-1">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                        <MapPin className="w-6 h-6 text-red-600" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <span className="text-xl font-bold text-gray-900">{route.from}</span>
                        <ArrowRight className="w-5 h-5 text-yellow-600" />
                        <span className="text-xl font-bold text-gray-900">{route.to}</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <span className="inline-block bg-yellow-100 text-yellow-800 text-xs font-semibold px-3 py-1 rounded-full">
                          {route.type}
                        </span>
                        <span className="text-sm text-gray-600">{route.description}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0">
                    <a href="#contact">
                      <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                        Get Quote
                      </button>
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Routes;